/**
 * Annotation Node Component for React Flow
 *
 * Renders freeform labels used in manual layout diagrams.
 */
import { memo } from "react";
import type { NodeProps } from "reactflow";
import type { ValueFlowNodeData } from "../../../../utils/schemaToReactFlow";

export const AnnotationNodeRF = memo(({ data }: NodeProps<ValueFlowNodeData>) => {
  const scale = Math.min(data.scale ?? 1, 1);
  const fontSize = Math.max(10, Math.round(12 * scale));
  return (
    <div
      className="pointer-events-none select-none text-sa-text-muted leading-tight whitespace-pre-line"
      style={{ fontSize: `${fontSize}px` }}
    >
      {data.label}
    </div>
  );
});

AnnotationNodeRF.displayName = "AnnotationNodeRF";
